import React, { useState, useEffect } from 'react';
import DataPipelineDashboard from './DataPipelineDashboard';
import SecurityDashboard from './SecurityDashboard';
import AnalyticsDashboard from './AnalyticsDashboard';

// Simple dashboard carousel with basic transitions and no headers
const DashboardCarousel = () => {
    const [activeDashboard, setActiveDashboard] = useState(0);

    // List of dashboards to rotate through
    const dashboards = [
        { component: <DataPipelineDashboard /> },
        { component: <SecurityDashboard /> },
        { component: <AnalyticsDashboard /> }
    ];

    // Handle automatic rotation
    useEffect(() => {
        const rotationInterval = setTimeout(() => {
            setActiveDashboard((prev) => (prev + 1) % dashboards.length);
        }, 5000); // 5 second rotation interval

        return () => clearTimeout(rotationInterval);
    }, [activeDashboard, dashboards.length]);

    return (
        <div className="min-h-screen bg-slate-950">
            {/* Simple crossfade between dashboards */}
            <div className="relative min-h-screen">
                {dashboards.map((dashboard, index) => (
                    <div
                        key={index}
                        className={`absolute inset-0 transition-opacity duration-700 ${index === activeDashboard ? 'opacity-100 z-10' : 'opacity-0 z-0'
                            }`}
                    >
                        {dashboard.component}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DashboardCarousel;